import { isSomething } from '../../../../../../utils/utils';
import { pipe, map, sum, flatten, filter } from 'ramda';

export const getTotalExpenseAndHours = (data) => {
  let cost = 0;
  let hours = 0;

  data?.map((milestone) => {
    Object.values(milestone?.services).map(({ totalHours, totalCost }) => {
      cost += totalCost;
      hours += totalHours;
      return '';
    });
    return '';
  });
  return { cost: cost, hours: hours };
};

export const getRateForRole = ({
  role,
  user,
  resources = [],
  projectRolesMap = {},
  companyRolesMap = {},
}) => {
  const userRole = user?.role;

  if (!role && !userRole) return 0;

  const safeResources = Array.isArray(resources) ? resources : [];

  // 1. Project resources (exact role match)
  if (role) {
    const match = safeResources.find((res) => res.role === role && res.rate != null);
    if (match?.rate != null) return match.rate;
  }

  // 2. Project rate card
  if (role && projectRolesMap[role]?.rate != null) {
    return projectRolesMap[role].rate;
  }

  if (userRole && projectRolesMap[userRole]?.rate != null) {
    return projectRolesMap[userRole].rate;
  }

  // 3. Company rate card
  if (role && companyRolesMap[role]?.rate != null) {
    return companyRolesMap[role].rate;
  }

  if (userRole && companyRolesMap[userRole]?.rate != null) {
    return companyRolesMap[userRole].rate;
  }

  // 4. Fallback
  return 0;
};

export const getFormattedExpenseDataForProject = (
  usersList,
  projectId,
  resources,
  projectRolesMap,
  companyRolesMap,
) => {
  if (!usersList) return [];

  const expenseData = pipe(
    map((user) => {
      const weeklyHours = user?.weeklyHours;
      const expenseItems = isSomething(weeklyHours) ? Object.values(weeklyHours) : [];

      return expenseItems?.flat()?.map((item) => {
        const hours = (item?.hours || [])
          .map((entry) => parseFloat(entry?.hours) || 0)
          .reduce((acc, value) => acc + value, 0);

        const deliverableId = item?.deliverableId || item?.deliverable;
        const role = item?.role;

        const rate = getRateForRole({
          role,
          user,
          resources,
          projectRolesMap,
          companyRolesMap,
        });

        return {
          flowId: item?.flowId,
          clientName: item?.clientName,
          deliverable: item?.deliverable,
          deliverableId: deliverableId,
          role,
          hours,
          cost: hours * rate,
          users: user,
        };
      });
    }),
    flatten,
    filter((x) => x?.flowId === projectId),
  )(usersList);

  return expenseData;
};
